import { ColumnDef } from '@tanstack/react-table';
import { ActiveSourcingChannelDetails } from 'api-clients/monolith';

import { useDataTable } from '@/hooks/use-data-table';

import { Cards } from './cards';

interface CampaignsProps {
  campaigns: ActiveSourcingChannelDetails[];
  columns: ColumnDef<ActiveSourcingChannelDetails>[];
  isLoading?: boolean;
}

export function Campaigns({
  campaigns,
  columns,
  isLoading = false,
}: CampaignsProps) {
  const { table } = useDataTable<ActiveSourcingChannelDetails>({
    columns,
    data: campaigns,
    rowCount: campaigns.length,
  });

  return (
    <div className="w-full">
      <div className="overflow-x-auto">
        <div className="min-w-max">
          <div className="space-y-4 pb-2">
            <Cards table={table} columns={columns} isLoading={isLoading} />
          </div>
        </div>
      </div>
    </div>
  );
}
